import React from 'react'

const History = () => {
  return (
    <div style={{backgroundImage:  'linear-gradient(rgba(0, 0, 0, 0.5),rgba(0, 0, 0, 0.5)) ,url("https://wallpaperaccess.com/full/4141105.jpg")',backgroundRepeat:'no-repeat',height:'100%',width:'100%',backgroundSize: 'cover',backgroundPosition: 'center'}}>
        <h1 style={{textAlign: 'center',color:'white'}}>The History of space Exploration</h1>
        <h2 style={{textAlign: 'center',color:'white', fontSize:'6mm'}}>The Most Influential Missions in Space Exploration</h2>
        <p style={{color: 'white',fontSize:'25px',paddingTop: ' 5px'}}>
            <strong>
                Pioneer 10 and 11
            <br />
            </strong>
            "1972-2003"
        </p>
        <ul style={{color: 'white',fontSize:'18px'}}>
            <li>The purpose of NASA's Pioneer missions was to learn about the outer reaches of the Solar System.</li>
            <li>These two spacecraft were, at the time of their launch, the most scientifically advanced vehicles to venture into the Solar System.</li>
            <li>They contained a number of technical instruments that had never been used in space before, which included a charged particle instrument to measure the extent of the Sun's influence as they travelled towards the edge of the Solar System, and an ultraviolet photometer to determine the composition of Jupiter’s atmosphere.</li>
            <li>While communication was lost in 2003 (Pioneer 10) and 1995 (Pioneer 11), the probes continue to make their way out of the Solar System, with each possessing an on board plaque detailing the origins of the spacecraft lest they are ever discovered by intelligent life-forms from another world.</li>
            <li>The Pioneer spacecraft were Earth's first deep space probes, and held the record for being the furthest man made objects from Earth until they were overtaken by the Voyager probes in the 1990s.</li>
        </ul>
        <img src='../images/Pioneer.jpg' alt=''/>

        <p style={{color: 'white',fontSize:'25px',paddingTop: ' 5px'}}>
            <strong>
                Venera probes
            <br />
            </strong>
            "1961-1984"
        </p>
        <ul style={{color: 'white',fontSize:'18px'}}>
            <li>The Venera missions have been Russia's most successful space exploration missions to date.</li>
            <li>23 separate probes were launched to the hottest planet in our Solar System- Venus</li>
            <li>23 separate probes were launched to the hottest planet in our Solar System- Venus.</li>
            <li>Each Venera lander was a technical marvel, withstanding temperature of up to 462 degrees Celsius to remain operational on the surface of Venus for up to two hours.</li>
            <li>They returned key data about the surface of the planet, including detailed information on the planet's atmospheric structure and its surface temperature.</li>
        </ul>
        <img src='../images/Venera.jpg' alt=''/>

        <p style={{color: 'white',fontSize:'25px',paddingTop: ' 5px'}}>
            <strong>
                Hayabusa
            <br />
            </strong>
            "2003-2010"
        </p>
        <ul style={{color: 'white',fontSize:'18px'}}>
            <li>Japan's Hayabusa probe was the first spacecraft to return a sample from an asteroid, but not without its problems.</li>
            <li>A fuel leak rendered its chemical engines unusable and, coupled with a variety of mechanical failures, the probe was forced to limp home on its weaker ion engines. It eventually arrived three years behind schedule in 2010, but the mission was a success.</li>
            <li>The use of ion engines has become more and more popular as, although they are not as powerful as chemical engines, they provide continual thrust for a much longer amount of time, allowing the vehicle to gradually build up speed rather than experiencing a large ‘push’ from a chemical engine at the start of its journey and subsequently being left to drift.</li>
        </ul>
        <img src='../images/Hayabusa.jpg' alt=''/>

        <p style={{color: 'white',fontSize:'25px',paddingTop: ' 5px'}}>
            <strong>
                Vostok 1
            <br />
            </strong>
            "1961"
        </p>
        <ul style={{color: 'white',fontSize:'18px'}}>
            <li>In 1961 Yuri Gagarin became the first man to travel to space, and the spacecraft that took him there for 68 minutes was somewhat of a rudimentary sphere known as Vostok 1.</li>
            <li>As the first manned craft to leave Earth orbit, extra precautions were taken that would later be deemed unnecessary for future space missions.</li>
            <li>Gagarin was not able to freely move around the cabin, nor was he able to manually control the spacecraft, owing to the fact that scientists were unsure how humans would cope in the weightless environment of space.</li>
            <li>Nonetheless, in the timeline of space exploration Vostok 1 is undoubtedly one of the most important spacecraft of all time.</li>
        </ul>
        <img src='../images/Vostok.jpg' alt=''/>

        <p style={{color: 'white',fontSize:'25px',paddingTop: ' 5px'}}>
            <strong>
                The Space Shuttle
            <br />
            </strong>
            "1981-2011"
        </p>
        <ul style={{color: 'white',fontSize:'18px'}}>
            <li>NASA's five space-faring Space Shuttles were the largest spacecraft of all time, and each completed numerous key missions that defined them as some of the most important vehicles to enter Earth orbit.</li>
            <li>Their various accolades include taking the Hubble Space Telescope into orbit (and later repairing it) and launching more than 80% of the modules for the International Space Station.</li>
            <li>There were 135 missions in total, but two of these ended in tragedy. The Challenger spacecraft exploded 73 seconds after launch in 1986, while in 2003 the Columbia spacecraft was torn apart on re-entry.</li>
            <li>While the Shuttles will be remembered largely as a success, these two disasters serve as a constant reminder of how dangerous it can be to attempt to take humans into orbit and return them to Earth.</li>
        </ul>
        <img src='../images/Space-Shuttle.jpg' alt=''/>

        <p style={{color: 'white',fontSize:'25px',paddingTop: ' 5px'}}>
            <strong>
                New Horizons
            <br />
            </strong>
            "2006-Present"
        </p>
        <ul style={{color: 'white',fontSize:'18px'}}>
            <li>NASA's New Horizons spacecraft will become the first man-made probe to fly by Pluto upon its arrival in 2015.</li>
            <li>While its primary mission is to study what was the 9th planet in the Solar System at the time of its launch, it has along the way also studied Jupiter and its moons.</li>
            <li>The New Horizons probe is the fastest probe to leave Earth’s orbit, attaining a speed of of over 36,000 mph after launch.</li>
            <li>It is currently more than 21 times further from the Sun than the Earth, beyond the orbit of Uranus. At that distance it takes almost 3 hours to send or receive a signal from the probe.</li>
        </ul>
        <img src='../images/New-Horizons.jpg' alt=''/>

        <p style={{color: 'white',fontSize:'25px',paddingTop: ' 5px'}}>
            <strong>
                Voyager 1 and 2
            <br />
            </strong>
            "1977-Present"
        </p>
        <ul style={{color: 'white',fontSize:'18px'}}>
            <li>The Pioneer spacecraft may have been the first deep space probes but they were not the last.</li>
            <li>The Voyager program was designed to explore Jupiter, Saturn, Uranus and Neptune, but as the probes remained in operation the mission was extended to include the study of the edge of the Solar System, the boundary into interstellar space, which they are currently entering.</li>
            <li>While communication was lost in 2003 (Pioneer 10) and 1995 (Pioneer 11), the probes continue to make their way out of the SolarLike several missions before and after, the Voyager probes both receive power from three radioisotope thermoelectric generators, using a plutonium-238 isotope to provide continual energy.</li>
            <li>On board each of the Voyager probes is a compendium of sounds and imagery from Earth known as the Golden Record, which also contains instructions on how to locate Earth should it one day be found by an alien race</li>
        </ul>
        <img src='../images/Voyager1.jpg' alt=''/>

        <p style={{color: 'white',fontSize:'25px',paddingTop: ' 5px'}}>
            <strong>
                "Galileo"
            <br />
            </strong>
            "1989-2003"
        </p>
        <ul style={{color: 'white',fontSize:'18px'}}>
            <li>NASA's Galileo spacecraft was taken into space by Space Shuttle Atlantis in 1989 and sent on its way to study Jupiter following flybys of Venus and Earth.</li>
            <li>It was the first spacecraft to obit Jupiter, in addition to performing the first flyby of an asteroid on its way to the gas giant.</li>
            <li>It also carried the Galileo Space Probe, which it released into the atmosphere of Jupiter in 1995, providing unprecedented data about the composition of the atmosphere of the largest planet in our Solar System.</li>
            <li>While communication was lost in 2003 (Pioneer 10) and 1995 (Pioneer 11), the probes continue to make their way out of the In 2003 the orbiting spacecraft was sent crashing into Jupiter, where it immediately burnt up, to prevent it accidentally crashing on and contaminating a nearby potentially life-harbouring moon in the future.</li>
        </ul>
        <img src='../images/Galileo.jpg' alt=''/>

        <p style={{color: 'white',fontSize:'25px',paddingTop: ' 5px'}}>
            <strong>
                Apollo 11
            <br />
            </strong>
            "1969"
        </p>
        <ul style={{color: 'white',fontSize:'18px'}}>
            <li>Apollo 11 was the first manned spacecraft to land on the Moon</li>
            <li>It was launched atop the most powerful rocket of all time, the Saturn V.</li>
            <li>The spacecraft was composed of two sections, the lunar module and the command module, the latter of which remained in orbit around the Moon with Michael Collins on board and the former taking astronauts Neil Armstrong and Buzz Aldrin to the surface.</li>
            <li>Apollo 11 paved the way for a further five successful missions to the Moon, each spending several days on the lunar surface.</li>
        </ul>
        <img src='../images/Apollo-11.jpg' alt=''/>

        <p style={{color: 'white',fontSize:'25px',paddingTop: ' 5px'}}>
            <strong>
                Cassini-Huygens
            <br />
            </strong>
            "1997-Present"
        </p>
        <ul style={{color: 'white',fontSize:'18px'}}>
            <li>Cassini-Huygens probe is a joint mission between, NASA, the ESA and ASI (Italian Space Agency).</li>
            <li>The orbiting component of the probe flew by Jupiter and became the first spacecraft to orbit Saturn, although it was only the fourth spacecraft to visit the latter.</li>
            <li>The landing vehicle was the Huygens probe, which landed on Saturn’s moon Titan on 14 January 2005 and returned images of the surface, the first and only successful landing in the outer Solar System.</li>
            <li>Like many other deep space probes it is powered by the isotope Plutonium-238, which has allowed its mission to be extended to 2017 as it travels further through the Solar System.</li>
            <li>Throughout its mission it has made countless important discoveries about the outer Solar System and it will continue to do so for the foreseeable future.</li>
        </ul>
        <img src='../images/Cassini-Huygens.jpg' alt=''/>
        <div style={{padding:'10px 0 0 250px'}}><iframe width="1000" height="550" src="https://www.youtube.com/embed/HgC4C4VHhWY?start=5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>
    </div>
    
  )
}

export default History